export default __webpack_public_path__ + "static/media/megane-rs-colour-5.ee475111.jpg";